import { render, staticRenderFns } from "./ContactView.vue?vue&type=template&id=2b5de39b&scoped=true"
import script from "./ContactView.vue?vue&type=script&lang=js"
export * from "./ContactView.vue?vue&type=script&lang=js"
import style0 from "./ContactView.vue?vue&type=style&index=0&id=2b5de39b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5de39b",
  null
  
)

export default component.exports